import { Text } from 'blaze-ui/Text/Text'
import Styles from './AutopilotSidebar.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Check } from 'screens/VirtualMarketerOnboarding/Loading/Check'
import { useOnboardingStrategiesEnabled } from 'flows/virtualMarketerOnboarding/steps'

export const AutopilotSidebar = () => {
  return (
    <BaseAutopilotSidebar
      sections={[
        {
          heading: 'Your Brand Profile',
          text: 'Blaze learned about your business from everything you shared. This profile guides your content strategy.',
        },
        {
          heading: 'How to edit',
          text: 'Click any section to refine it. Hit "Looks Good" when you’re finished.',
        },
      ]}
    />
  )
}

interface Section {
  heading: string
  text: string
}

export const BaseAutopilotSidebar = ({ sections }: { showSupportButton?: boolean; sections: Section[] }) => {
  const isOnboardingStrategiesEnabled = useOnboardingStrategiesEnabled()

  return (
    <div className={Styles.brandProfileSideContentWrapper}>
      <div className={Styles.brandProfileSideContent}>
        <div className={Styles.item}>
          <Heading level={5}>Does this look right?</Heading>
          <Text variant="secondary" color="var(--dark-80)">
            We built this from your website. Fix anything that's off.
          </Text>
        </div>
        <div className={Styles.itemWithList}>
          <Heading level={5}>What to check:</Heading>
          <div className={Styles.listItem}>
            <div className={Styles.check}>
              <Check color="var(--light-100)" />
            </div>
            <Text variant="secondary" color="var(--dark-80)">
              Core identity is accurate
            </Text>
          </div>
          <div className={Styles.listItem}>
            <div className={Styles.check}>
              <Check color="var(--light-100)" />
            </div>
            <Text variant="secondary" color="var(--dark-80)">
              {isOnboardingStrategiesEnabled ? 'Target audience is relevant' : 'Market positioning makes sense'}
            </Text>
          </div>
          <div className={Styles.listItem}>
            <div className={Styles.check}>
              <Check color="var(--light-100)" />
            </div>
            <Text variant="secondary" color="var(--dark-80)">
              {isOnboardingStrategiesEnabled
                ? 'Marketing positioning makes sense'
                : 'Competitive advantages are complete'}
            </Text>
          </div>
        </div>
        <div className={Styles.item}>
          <Heading level={5}>Need to add or edit?</Heading>
          <Text variant="secondary" color="var(--dark-80)">
            Click any section to edit.
          </Text>
        </div>
        <div className={Styles.item}>
          <Heading level={5}>Why this matters:</Heading>
          <Text variant="secondary" color="var(--dark-80)">
            The more accurate this is, the better your content will be.
          </Text>
        </div>
      </div>
    </div>
  )
}
